import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '@/views/home.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/auditsheet2',
    name: 'sheet2',
    component: () => import('@/views/auditsheet2.vue')
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router